

import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';
import { appContext } from '../../../../../app.context';
import { NumbersService } from '../../../../../services/ui/numbers.service';
import { FormService } from '../../../../../services/ui/form.service';

class ScontoMaggiorazionePRModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$uibModal',
        '$sce',
        'NumbersService',
        'FormService'
    ];

    private close: any;
    private settings: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $sce: ng.ISCEService,
        private numberService: NumbersService,
        private formService: FormService
    ) {
        /* tslint:disable:no-string-literal */
        // dettaglioLinee:
        this.settings = $scope.$parent.$resolve.settings;

        $scope.TipoScontoMaggiorazioneType = {
            'SC': 'SC = Sconto',
            'MG': 'MG = Maggiorazione'
        };

        let itemTemplate = {
            Tipo: '',
            Percentuale: '',
            Importo: ''
        };

        $scope.items = this.settings.scontoMaggiorazione.map(item => {
          return {...itemTemplate, ...item};
        });

        $scope.addItem = () => {
            $scope.items.push(jQuery.extend(true, {}, itemTemplate));
        };

        $scope.removeItem = (index: number) => {
          $scope.items.splice(index, 1);
        };

        $scope.save = (errors) => {

          this.close({$value: $scope.items
            .filter(item =>  (item.Percentuale !== '' || item.Percentuale !== '0.00') && (item.Importo !== '' ||  item.Importo !== '0.00'))
            .map(item => {
              if (item.Percentuale === '' || item.Percentuale === '0.00') {
                delete item.Percentuale;
              }
              if (item.Importo === '' || item.Importo === '0.00') {
                delete item.Importo;
              }
              return item;
            })});
        };

        $scope.cancel = () => {
            this.close({$value: []});
        };
    }
}

export const ScontoMaggiorazionePRModalComponent: ng.IComponentOptions = {
    template: require('./sconto-maggiorazione-modal-component.html'),
    controller: ScontoMaggiorazionePRModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/sconto-maggiorazione-modal-component/sconto-maggiorazione-modal-component.ts